export const precautionaryStatements = {
  P101: 'If medical advice is needed, have product container or label at hand.',
  P102: 'Keep out of reach of children.',
  P103: 'Read label before use.',
  P201: 'Obtain special instructions before use.',
  P202:
    'Do not handle until all safety precautions have been read and understood.',
  P210:
    'Keep away from heat, hot surfaces, sparks, open flames and other ignition sources. No smoking. [As modified by IV ATP]',
  P211: 'Do not spray on an open flame or other ignition source.',
  P220:
    'Keep/Store away from clothing/…/combustible materials. [As modified by IV ATP]',
  P221: 'Take any precaution to avoid mixing with combustibles.',
  P222: 'Do not allow contact with air.',
  P223: 'Do not allow contact with water. [As modified by IV ATP]',
  P230: 'Keep wetted with …',
  P231: 'Handle under inert gas.',
  P232: 'Protect from moisture.',
  P233: 'Keep container tightly closed.',
  P234: 'Keep only in original container.',
  P235: 'Keep cool..',
  P240: 'Ground/bond container and receiving equipment.',
  P241: 'Use explosion-proof electrical/ventilating/light/…/equipment.',
  P242: 'Use only non-sparking tools.',
  P243: 'Take precautionary measures against static discharge.',
  P244:
    'Keep valves and fittings free from oil and grease. [As modified by IV ATP]',
  P250: 'Do not subject to grinding/shock/…/friction.',
  P251: 'Do not pierce or burn, even after use. [As modified by IV ATP]',
  P260: 'Do not breathe dust/fume/gas/mist/vapours/spray.',
  P261:
    'Avoid breathing dust/fume/ gas/mist/vapours/spray. [As modified by IV ATP]',
  P262: 'Do not get in eyes, on skin, or on clothing.',
  P263: 'Avoid contact during pregnancy/while nursing.',
  P264: 'Wash … thoroughly after handling.',
  P270: 'Do not eat, drink or smoke when using this product.',
  P271: 'Use only outdoors or in a well-ventilated area.',
  P272:
    'Contaminated work clothing should not be allowed out of the workplace.',
  P273: 'Avoid release to the environment.',
  P280:
    'Wear protective gloves/protective clothing/eye protection/face protection. [As modified by IV ATP]',
  P281: '[Deleted by IV ATP]',
  P282: 'Wear cold insulating gloves/face shield/eye protection.',
  P283: 'Wear fire/flame resistant/retardant clothing.',
  P284:
    '[In case of inadequate ventilation] wear respiratory protection. [As modified by IV ATP]',
  P285: '[Deleted by IV ATP]',
  'P231+232': 'Handle under inert gas. Protect from moisture',
  'P235+410': 'Keep cool. Protect from sunlight',
  P301: 'IF SWALLOWED:',
  P302: 'IF ON SKIN:',
  P303: 'IF ON SKIN (or hair):',
  P304: 'IF INHALED:',
  P305: 'IF IN EYES:',
  P306: 'IF ON CLOTHING:',
  P307: '[Deleted by IV ATP]',
  P308: 'IF exposed or concerned:',
  P309: '[Deleted by IV ATP]',
  P310: 'Immediately call a POISON CENTER/doctor/… [As modified by IV ATP]',
  P311: 'Call a POISON CENTER/ doctor/… [As modified by IV ATP]',
  P312:
    'Call a POISON CENTER/ doctor/…/if you feel unwell. [As modified by IV ATP]',
  P313: 'Get medical advice/attention.',
  P314: 'Get Medical advice/attention if you feel unwell.',
  P315: 'Get immediate medical advice/attention.',
  P320: 'Specific treatment is urgent (see … on this label).',
  P321: 'Specific treatment (see … on this label).',
  P322: '[Deleted by IV ATP]',
  P330: 'Rinse mouth.',
  P331: 'Do NOT induce vomiting.',
  P332: 'If skin irritation occurs:',
  P333: 'If skin irritation or a rash occurs:',
  P334: 'Immerse in cool water/wrap in wet bandages.',
  P335: 'Brush off loose particles from skin.',
  P336: 'Thaw frosted parts with lukewarm water. Do not rub affected areas.',
  P337: 'If eye irritation persists:',
  P338: 'Remove contact lenses if present and easy to do. continue rinsing.',
  P340: 'Remove person to fresh air and keep comfortable for breathing.',
  P341: '[Deleted by IV ATP]',
  P342: 'If experiencing respiratory symptoms:',
  P350: '[Deleted by IV ATP]',
  P351: 'Rinse cautiously with water for several minutes.',
  P352: 'Wash with plenty of water/… [As modified by IV ATP]',
  P353: 'Rinse skin with water/shower.',
  P360:
    'Rinse immediately contaminated clothing and skin with plenty of water before removing clothes.',
  P361:
    'Take off immediately all contaminated clothing. [As modified by IV ATP]',
  P362: 'Take off contaminated clothing. [As modified by IV ATP]',
  P363: 'Wash contaminated clothing before reuse. [As modified by IV ATP]',
  P364: 'And wash it before reuse. [Added by IV ATP]',
  P370: 'In case of fire:',
  P371: 'In case of major fire and large quantities:',
  P372: 'Explosion risk in case of fire.',
  P373: 'DO NOT fight fire when fire reaches explosives.',
  P374: 'Fight fire with normal precautions from a reasonable distance.',
  P375: 'Fight fire remotely due to the risk of explosion.',
  P376: 'Stop leak if safe to do so.',
  P377:
    'Leaking gas fire – do not extinguish unless leak can be stopped safely.',
  P378: 'Use … to extinguish.',
  P380: 'Evacuate area.',
  P381: 'Eliminate all ignition sources if safe to do so.',
  P391: 'Collect spillage.',
  'P301+310':
    'IF SWALLOWED: Immediately call a POISON CENTER/doctor/… [As modified by IV ATP]',
  'P301+312':
    'IF SWALLOWED: Call a POISON CENTER/doctor/…/if you feel unwell. [As modified by IV ATP]',
  'P301+330+331': 'IF SWALLOWED: Rinse mouth. Do NOT induce vomiting.',
  'P302+334': 'IF ON SKIN: Immerse in cool water/wrap in wet bandages.',
  'P302+350': '[Deleted by IV ATP]',
  'P302+352': 'IF ON SKIN: Wash with plenty of water/… [As modified by IV ATP]',
  'P303+361+353':
    'IF ON SKIN (or hair): Take off immediately all contaminated clothing. Rinse skin with water/ shower. [As modified by IV ATP]',
  'P304+312':
    'IF INHALED: Call a POISON CENTER or doctor/physician if you feel unwell.',
  'P304+340':
    'IF INHALED: Remove person to fresh air and keep comfortable for breathing. [As modified by IV ATP]',
  'P304+341': '[Deleted by IV ATP]',
  'P305+351+338':
    'IF IN EYES: Rinse cautiously with water for several minutes. Remove contact lenses if present and easy to do – continue rinsing.',
  'P306+360':
    'IF ON CLOTHING: Rinse immediately contaminated clothing and skin with plenty of water before removing clothes.',
  'P307+311': 'IF exposed: Call a POISON CENTER or doctor/physician.',
  'P308+311':
    'IF exposed or concerned: Call a POISON CENTER/ doctor/… [Added by IV ATP]',
  'P309+311': '[Deleted by IV ATP]',
  'P332+313': 'If skin irritation occurs: Get medical advice/attention.',
  'P333+313':
    'If skin irritation or a rash occurs: Get medical advice/attention.',
  'P335+334':
    'Brush off loose particles from skin. Immerse in cool water/wrap in wet bandages.',
  'P337+313': 'If eye irritation persists get medical advice/attention.',
  'P342+311':
    'If experiencing respiratory symptoms: Call a POISON CENTER/doctor/… [As modified by IV ATP]',
  'P361+364':
    'Take off immediately all contaminated clothing and wash it before reuse. [Added by IV ATP]',
  'P362+364':
    'Take off contaminated clothing and wash it before reuse. [Added by IV ATP]',
  'P370+376': 'In case of fire: Stop leak if safe to do so.',
  'P370+378': 'In case of fire: Use … to extinguish. [As modified by IV ATP]',
  'P370+380': 'In case of fire: Evacuate area.',
  'P370+380+375':
    'In case of fire: Evacuate area. Fight fire remotely due to the risk of explosion.',
  'P371+380+375':
    'In case of major fire and large quantities: Evacuate area. Fight fire remotely due to the risk of explosion.',
  P401: 'Store …',
  P402: 'Store in a dry place.',
  P403: 'Store in a well ventilated place.',
  P404: 'Store in a closed container.',
  P405: 'Store locked up.',
  P406:
    'Store in a corrosive resistant/… container with a resistant inner liner.',
  P407: 'Maintain air gap between stacks/pallets.',
  P410: 'Protect from sunlight.',
  P411: 'Store at temperatures not exceeding … °C/… °F.',
  P412: 'Do not expose to temperatures exceeding 50 °C/122 °F.',
  P413:
    'Store bulk masses greater than … kg/… lbs at temperatures not exceeding … °C/… °F.',
  P420: 'Store away from other materials.',
  P422: 'Store contents under …',
  'P402+404': 'Store in a dry place. Store in a closed container.',
  'P403+233':
    'Store in a well ventilated place. Keep container tightly closed.',
  'P403+235': 'Store in a well ventilated place. Keep cool.',
  'P410+403': 'Protect from sunlight. Store in a well-ventilated place.',
  'P410+412':
    'Protect from sunlight. Do not expose to temperatures exceeding 50 °C/122 °F.',
  'P411+235': 'Store at temperatures not exceeding … °C/… °F. Keep cool.',
  P501:
    'Dispose of contents/container to … [… in accordance with local/regional/national/international regulation (to be specified)].',
};
